import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ShieldCheck, MapPin, Lock, Flag, BadgeCheck } from "lucide-react";

const TIPS = [
  { icon: MapPin, title: "shTip1Title", body: "shTip1Body" },
  { icon: Lock, title: "shTip2Title", body: "shTip2Body" },
  { icon: Flag, title: "shTip3Title", body: "shTip3Body" },
  { icon: BadgeCheck, title: "shTip4Title", body: "shTip4Body" },
];

/** Safety Hub — safety guidance, Yubo-style. */
export default function SafetyHub() {
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-white text-[#0A0B0D] max-w-2xl mx-auto pb-32" data-testid="safety-hub-page">
      <div className="sticky top-0 z-30 bg-white border-b border-[#E2DFD4]">
        <div className="flex items-center gap-4 px-5 py-5">
          <button onClick={() => nav(-1)} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full hover:bg-[#F4F1E8]" data-testid="safetyhub-back" aria-label="Back">
            <ArrowLeft className="w-7 h-7" strokeWidth={3} />
          </button>
          <h1 className="font-display font-black text-[28px] tracking-tight">{t("settings.safetyHubTitle")}</h1>
        </div>
      </div>

      <div className="px-5 pt-6">
        <div className="flex items-center gap-3 bg-[#E6FBF9] border-2 border-[#121212] rounded-2xl p-4 mb-6">
          <ShieldCheck className="w-8 h-8 text-[#0F9D8F] shrink-0" strokeWidth={2.5} />
          <p className="text-sm font-semibold">{t("settings.safetyHubIntro")}</p>
        </div>

        <div className="space-y-5">
          {TIPS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-4" data-testid={`safety-tip-${title}`}>
              <div className="w-11 h-11 rounded-full bg-[#F4F1E8] flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-[#0A0B0D]" strokeWidth={2.5} />
              </div>
              <div>
                <h3 className="font-display font-black text-base">{t(`settings.${title}`)}</h3>
                <p className="text-sm text-[#4A4F58] mt-0.5">{t(`settings.${body}`)}</p>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={() => nav("/settings/privacy")}
          className="mt-8 w-full bg-[#00CED1] text-black font-black py-3.5 rounded-2xl border-2 border-[#121212] shadow-[3px_3px_0_#121212]"
          data-testid="safetyhub-privacy-btn"
        >
          {t("settings.helpMyPrivacy")}
        </button>
      </div>
    </div>
  );
}
